module.exports = __webpack_public_path__ + "static/img/huanzhe5.0b9fe18f.webp";